module.exports = __webpack_public_path__ + "img/vitaa_slimane.c286616b.jpg";